document.addEventListener("DOMContentLoaded", () => {

  // Solo si es Giftcard
  if (window.meta?.product?.type === "Giftcard") {
    const removeFBT = () => {
      const fbtSection = document.querySelector(".cbb-frequently-bought-container");
      if (fbtSection) {
        fbtSection.remove();
        console.log("🧹 Se eliminó 'Comprados juntos habitualmente'");
        return true;
      }
      return false;
    };

    // Intento inmediato
    if (!removeFBT()) {
      const observer = new MutationObserver(() => {
        if (removeFBT()) observer.disconnect(); // desconecta al encontrarlo
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // ✅ Si venimos de agregar un producto normal
  if (localStorage.getItem("openMiniCartAfterReload") === "true") {
    localStorage.removeItem("openMiniCartAfterReload");

    setTimeout(() => {
      const cartTrigger = document.querySelector('.t4s-site-nav__cart a[data-drawer-options]');
      if (cartTrigger) cartTrigger.click();
    }, 300);
  }

  // --- MODAL ---
  const showCartModal = (message, reloadAfterClose = false) => {
    const modal = document.getElementById("cart-alert-modal");
    const messageEl = document.getElementById("cart-alert-message");
    const closeBtn = document.getElementById("cart-alert-close");

    if (!modal || !messageEl || !closeBtn) return;

    messageEl.textContent = message;
    modal.style.display = "flex";

    const closeHandler = () => {
      modal.style.display = "none";
      closeBtn.removeEventListener("click", closeHandler);
      if (reloadAfterClose) window.location.reload();
    };

    closeBtn.addEventListener("click", closeHandler);
  };

  //Refrescar el minicart
  const refreshMiniCart = async () => {
    try {
      const res = await fetch("/?sections=mini-cart");
      const data = await res.json(); 
      
      // Shopify devuelve la sección como string HTML
      const htmlString = data["mini-cart"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");

      const newMiniCart = doc.querySelector("#t4s-mini_cart");
      const currentMiniCart = document.querySelector("#t4s-mini_cart");

      if (currentMiniCart && newMiniCart) {
        currentMiniCart.innerHTML = newMiniCart.innerHTML;
      }

      // actualizar contador y total
      const newCount = doc.querySelector("[data-cart-count]");
      const newTotal = doc.querySelector("[data-cart-tt-price]");
      const headerCount = document.querySelector("[data-cart-count]");
      const headerTotal = document.querySelector("[data-cart-tt-price]");

      if (headerCount && newCount) headerCount.textContent = newCount.textContent;
      if (headerTotal && newTotal) headerTotal.textContent = newTotal.textContent;

      // abrir minicart automáticamente
      setTimeout(() => {
        const cartTrigger = document.querySelector('.t4s-site-nav__cart a[data-drawer-options]');
        if (cartTrigger) cartTrigger.click();
      }, 100);

      return true;
    } catch (err) {
      console.error("❌ Error refrescando el minicart:", err);
      return false;
    }
  };
  
  // --- Función de validación y agregado ---
  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    const isGiftCard = window.meta?.product?.type === "Giftcard";
    // Obtener el formulario: puede ser e.target (si es submit) o el formulario más cercano (si es click)
    const form = e.target.tagName === 'FORM' ? e.target : e.target.closest("form");
    if (!form) {
      console.warn("⚠️ No se encontró el formulario");
      return;
    }
    
    const variantInput = form.querySelector("input[name='id'], select[name='id']");
    const variantId = variantInput?.value;
    
    // Obtener la cantidad del formulario
    const quantityInput = form.querySelector("input[name='quantity']");
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    if (!variantId) {
      console.warn("⚠️ No se encontró");
      return;
    }

    // �� CAPTURAR DATOS DEL DESTINATARIO SI ES GIFT CARD
    let giftCardProperties = {};
    if (isGiftCard) {
      // Capturar datos del formulario de destinatario
      const recipientEmail = form?.querySelector('input[name="properties[Recipient email]"]')?.value;
      const recipientName = form?.querySelector('input[name="properties[Recipient name]"]')?.value;
      const message = form?.querySelector('textarea[name="properties[Message]"]')?.value;
      const sendOn = form?.querySelector('input[name="properties[Send on]"]')?.value;
      const sendToRecipient = form?.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]')?.value;
      const recipientCheckbox = form?.querySelector('input[name^="recipient-checkbox-"]')?.checked;
      const timezoneOffset = form?.querySelector('input[name="properties[__shopify_offset]"]')?.value;

      // Solo agregar propiedades si hay datos
      if (recipientEmail) giftCardProperties['Recipient email'] = recipientEmail;
      if (recipientName) giftCardProperties['Recipient name'] = recipientName;
      if (message) giftCardProperties['Message'] = message;
      if (sendOn) giftCardProperties['Send on'] = sendOn;
      if (recipientCheckbox && sendToRecipient) {
        giftCardProperties['__shopify_send_gift_card_to_recipient'] = sendToRecipient;
      }
      if (timezoneOffset) giftCardProperties['__shopify_offset'] = timezoneOffset;

      console.log("�� Datos del destinatario capturados:", giftCardProperties);
    }

    // Revisar el carrito actual
    let cart;
    try {
      const res = await fetch("/cart.js");
      cart = await res.json();
    } catch (err) {
      console.error("❌ Error obteniendo el carrito:", err);
      return;
    }

    const hasGiftcard = cart.items.some(item => item.product_type === "Giftcard");
    const hasNormal = cart.items.some(item => item.product_type !== "Giftcard");

    //console.log("➡️ El carrito tiene giftcard?:", hasGiftcard);
    //console.log("➡️ El carrito tiene productos normales?:", hasNormal);

    let canAdd = true;

    // --- CASO 1: Giftcard + productos normales ---
    if (isGiftCard && hasNormal) {
      showCartModal(window.cartMessages?.giftcardWithProducts || "⚠️ No puedes añadir tarjeta de regalo cuando ya tienes productos en el carrito.");
      return;
    }

    // --- CASO 2: Producto normal + giftcard ---
    if (!isGiftCard && hasGiftcard) {
      
      try {
        // Limpiar carrito
        await fetch("/cart/clear.js", { method: "POST" });
        // Agregar producto normal
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        });
        localStorage.setItem("openMiniCartAfterReload", "true");
        // Muestra modal primero y recargar SOLO después de cerrarlo
        showCartModal(
          window.cartMessages?.productsWithGiftcard || 
          "⚠️ No puedes añadir productos normales mientras haya tarjeta de regalo en el carrito. Se reemplazará la giftcard.",
          true 
        );
        //await refreshMiniCart();
      } catch (err) {
        console.error("❌ Error al reemplazar giftcard:", err);
      }
      return;
    }

    // --- Agregar al carrito si pasa validaciones ---
    if (canAdd) {
      try {
        // �� PREPARAR DATOS PARA ENVÍO
        const cartData = { 
          id: variantId, 
          quantity: quantity 
        };
        
        // Agregar propiedades de Gift Card si existen
        if (Object.keys(giftCardProperties).length > 0) {
          cartData.properties = giftCardProperties;
        }

        console.log("📦 Enviando al carrito:", cartData);

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(cartData)
        });
        
        localStorage.setItem("openMiniCartAfterReload", "true");
        window.location.reload();
        //await refreshMiniCart();
      } catch (err) {
        console.error("❌ Error al agregar al carrito:", err);
      }
    }
  };
  document.addEventListener("click", (e) => {
    // No interceptar clicks en botones de cantidad
    if (e.target.closest("[data-quantity-selector]")) {
      return;
    }
    const btn = e.target.closest(".t4s-product-form__submit");
    if (!btn) return;
    handleAddToCart(e);
  }, true);

  // --- Evento submit de formulario (usando delegación de eventos para formularios dinámicos) ---
  document.addEventListener("submit", (e) => {
    // Cuando es submit, e.target es el formulario
    const form = e.target.tagName === 'FORM' && e.target.classList.contains('t4s-product-form') 
      ? e.target 
      : e.target.closest("form.t4s-product-form");
    if (form) {
      handleAddToCart(e);
    }
  }, true);
});